import { useState, useEffect } from "react"
import useMediaQuery from "./useMediaQuery"

export type ScreenSize = "mobile" | "tablet" | "full"

export const useScreenSize = (): ScreenSize | undefined => {
  const [screenSize, setScreenSize] = useState<ScreenSize | undefined>(
    undefined
  )

  const fullSize = useMediaQuery("screen and (min-width: 52em)")
  const tabletSize = useMediaQuery("screen and (min-width: 40em)")

  useEffect(() => {
    if (fullSize) {
      setScreenSize("full")
    } else if (tabletSize) {
      setScreenSize("tablet")
    } else {
      setScreenSize("mobile")
    }
  }, [fullSize, tabletSize])

  return screenSize
}
